
import { defineComponent } from 'vue';

import PageHeaderBase from './PageHeaderBase.vue';

export default defineComponent({
  name: 'SPageHeader',
  components: {
    PageHeaderBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    backLabel: {
      type: String,
      default: '',
    },
    backMargin: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    back: {
      type: [String, Object],
    },
  },
});
